module.exports = __webpack_public_path__ + "img/vpn-7.fcfcf0a3.webp";